import { msg } from "../messages";
import type { ExpiringItemView, RecipeIngredient } from "../types/dashboard";

export type IngredientExpiryStatus = "expired" | "expiring";

export function getIngredientExpiryStatus(
    ingredient: RecipeIngredient,
    expiringItems: ExpiringItemView[],
): IngredientExpiryStatus | null {
    if (ingredient.itemId === undefined) return null;
    const item = expiringItems.find((e) => e.id === ingredient.itemId);
    if (!item || item.daysLeft === null) return null;
    if (item.daysLeft < 0) return "expired";
    if (item.daysLeft <= 7) return "expiring";
    return null;
}

export function formatIngredientExpiryLabel(
    ingredient: RecipeIngredient,
    expiringItems: ExpiringItemView[],
): string {
    const status = getIngredientExpiryStatus(ingredient, expiringItems);
    if (status === "expired") {
        return msg("recipe-sheet/expired-prefix", { label: ingredient.label });
    }
    if (status === "expiring") {
        return msg("recipe-sheet/expiring-prefix", { label: ingredient.label });
    }
    return ingredient.label;
}

/** @deprecated Use getIngredientExpiryStatus */
export function isIngredientExpiringSoon(
    ingredient: RecipeIngredient,
    expiringItems: ExpiringItemView[],
): boolean {
    return getIngredientExpiryStatus(ingredient, expiringItems) !== null;
}
